<template>
  <div class="global-header view-flex view-flex-middle">
    <div class="logo view-flex view-flex-center">
      <div class="logo-img">
        <img :src="shop">
      </div>
    </div>
    <div class="navs">
      <div class="nav-item">
        <router-link
          to="/"
          :class="{ 'module-active': moduleName == 'marketCenter' }"
        >
          营销中心
        </router-link>
      </div>
      <div class="nav-item">
        <router-link
          to="/salescenter"
          :class="{ 'module-active': moduleName == 'salesCenter' }"
        >
          销售中心
        </router-link>
      </div>
    </div>
    <div class="user-info view-flex view-flex-item view-flex-right">
      <div class="user-index">
        <el-popover
          placement="bottom"
          trigger="hover"
          popper-class="logout-popper"
        >
          <div
            v-if="moduleName == 'marketCenter'"
            class="content-padded dom-link user-list"
            @click="goAccount"
          >
            <img
              src="@/assets/img/mine.png"
              alt=""
            > 账号信息
          </div>
          <div
            class="section-footer with-border dom-link user-list"
            @click="logout"
          >
            <img
              src="@/assets/img/logout.png"
              alt=""
            > 退出登录
          </div>
          <div
            slot="reference"
            class="user-btn"
          >
            <img
              v-if="userInfo && userInfo.user_info"
              class="user-avatar"
              :src="userInfo.user_info.avatar"
            >
            <el-avatar
              v-else
              shape="square"
              :size="30"
              src="https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png"
            />
            <div class="iconfont nick_name">
              {{ userInfo.user_info.user_name }}
            </div>
          </div>
        </el-popover>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * @author wjb
 * @description 公共头部：登入后layout默认公共头
 * @see The http://salesperson.ex-sandbox.com/index @/view/layout.vue
 * @since version 1.0
 * @returns {void}
 *
 */
const shop = require(`@/assets/img/components/shoplogo.png`)
import { mapMutations } from 'vuex'
import Router from '@/router/index'
export default {
  name: 'SpGlobalHeader',
  data () {
    return {
      shop: shop
    }
  },
  computed: {
    moduleName () {
      const { module = 'marketCenter' } = this.$route.meta
      return module
    },
    userInfo () {
      const defaultInfo = {
        user_info: {
          avatar:
            'http://mmbiz.qpic.cn/mmbiz_png/1nDJByqmW2fWRCf9MOPpRLdKxwlTEzLqfgIeP8SVeBAWuyMW3K5ACK4PsCX7vDBkOHKSLFXNQrKy8ibaTPpia7TQ/0?wx_fmt=png',
          user_name: '欢迎'
        }
      }
      let userInfo = {}
      if (this.$store.getters.userInfo && this.$store.getters.userInfo.user_info) {
        userInfo = this.$store.getters.userInfo
      } else {
        userInfo = defaultInfo
      }
      return userInfo
    }
  },
  methods: {
    ...mapMutations(['clearUser', 'clearMenu', 'setGlobalMenuType']),
    handleClick (tab, event) {
      this.$emit('tabClick', tab)
    },
    clearIframeMessage () {
      const self = this
      const iframe = document.getElementById('iframeWin')

      console.log('导购端正在退出登录...', iframe)

      setTimeout(function () {
        console.log('导购端正在退出登录啊啊啊...', iframe)
        console.log('Dom', iframe)
        console.log('iframe.contentWindow', iframe.contentWindow)
      }, 3000)
    },
    async logout () {
      await this.$api.auth.logout()
      this.clearMenu()
      this.clearUser()
      this.setGlobalMenuType('wechat')
      this.clearIframeMessage()
      const loginPath =
        process.env.VUE_APP_STATUS == 'uat' || location.host == 'jd.yuanyuanke.cn'
          ? '/auth/phoneLogin'
          : '/auth/login'
      Router.push({ path: loginPath, replace: true })
    },
    goAccount () {
      Router.push({ path: '/setting/account', replace: true })
    }
  }
}
</script>

<style lang="scss">
.global-header {
  height: 100%;
  background: #e8e8e8;
  justify-content: space-between;
  margin: 0 -20px;
  z-index: 100;
  box-shadow: 0px 2px 6px 0px rgba(0, 21, 41, 0.2);

  .logo {
    width: 264px;
    color: white;
    position: relative;

    &:after {
      display: block;
      content: '';
      position: absolute;
      height: 23px;
      width: 1px;
      background: #cccccc;
      right: 0;
    }

    &-img {
      width: 88px;
      height: 26px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    &-text {
      font-weight: 600;
      font-size: 16px;
      margin-left: 10px;
    }
  }

  .tabs {
    width: 500px;

    .el-tabs {
      &__item {
        color: white;
        height: 52px;
        line-height: 52px;

        &.is-top:nth-child(2) {
          padding-left: 20px;
        }
        &.is-active {
          color: #1480e3;
        }
      }
      &__nav-wrap::after {
        background-color: transparent;
      }
      &__header {
        margin: 0;
      }
      &__nav {
        height: 52px;
      }
    }
  }

  .navs {
    display: flex;
    margin-left: 25px;
    .nav-item {
      height: 50px;
      line-height: 50px;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #111111;
      margin-right: 46px;

      a {
        color: #111111;
        position: relative;
        &.module-active {
          &::after {
            height: 2px;
            content: '';
            width: 100%;
            background: #1890ff;
            position: absolute;
            left: 0;
            right: 0;
            bottom: -17px;
          }
        }
      }
    }
  }

  .user-info {
    height: 100%;

    .user-index {
      padding-right: 22px;
      .user-btn {
        display: flex;
        align-items: center;
      }
    }

    span:nth-child(1) {
      height: 100%;
    }

    .el-popover__reference-wrapper {
      line-height: 40px;
      height: 100%;
      display: flex;
      align-items: center;

      .nick_name {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.65);
        margin-left: 8px;
      }
    }

    > span {
      display: flex;
      width: 50px;
      height: 50px;
    }
    .user-avatar {
      margin-right: 0;
    }
    .iconfont {
      transition: all 0.3s ease;
      // color: $dominant_hue;
      font-size: 28px;
      cursor: pointer;
    }
    &:hover {
      .iconfont {
        opacity: 0.7;
      }
    }
  }
}
.user-avatar {
  width: 30px;
  height: 30px;
  font-size: 30px;
  margin-right: 5px;
  border-radius: 4px;
}
.user-list {
  display: flex;
  align-items: center;
  img {
    width: 16px;
    height: 16px;
    margin-right: 10px;
  }
}
</style>
